import React, {useEffect} from "react";
import {useAuthStore} from "../../redux/auth";
import {AuthStatus} from "../../models";
import {clearMonitoringUser, setMonitoringUser} from "../../services/monitoring";

/**
 * Keeps the Sentry user identity in sync with auth state: set (uuid only) while
 * logged in, cleared otherwise. Render-less.
 */
const MonitoringListener: React.FC = () => {
    const {authStatus, user} = useAuthStore();

    useEffect(() => {
        if (authStatus === AuthStatus.LOGGED_IN && user?.uuid) {
            setMonitoringUser({uuid: user.uuid});
        } else {
            clearMonitoringUser();
        }
    }, [authStatus, user?.uuid]);

    return null;
};

export default MonitoringListener;
